module.exports = __webpack_public_path__ + "static/media/input.2cc85b6a.png";